import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { Database, Loader2 } from 'lucide-react'
import { useAuth } from '../hooks/useAuth'

export function ProtectedRoute({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className='min-h-screen flex flex-col items-center justify-center bg-background text-foreground font-sans overflow-hidden relative'>
        <div className='absolute inset-0 bg-gradient-to-tr from-blue-100/60 via-background to-purple-100/60 pointer-events-none' />
        <div className='relative z-10 flex flex-col items-center gap-6'>
          <div className='relative'>
            <div className='h-14 w-14 sm:h-16 sm:w-16 rounded-2xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-xl shadow-blue-500/25'>
              <Database className='text-white h-8 w-8 sm:h-9 sm:w-9' />
            </div>
            <div className='absolute -bottom-1 -right-1 h-6 w-6 rounded-full bg-background border-2 border-white flex items-center justify-center shadow'>
              <Loader2 className='h-3.5 w-3.5 text-primary animate-spin' />
            </div>
          </div>
          <div className='text-center space-y-1'>
            <p className='font-semibold text-lg bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-purple-600'>
              DataMatch
            </p>
            <p className='text-sm text-muted-foreground animate-pulse'>
              Just a moment...
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to='/login' state={{ from: location }} replace />
  }

  return <>{children}</>
}
